// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ul.other_icons li a.cartbadge .notification-badge{position:absolute;top:11px;background:#fdb614;width:20px;height:20px;border-radius:10px;text-align:center;color:#000;line-height:22px;font-size:13px;font-weight:700;right:-14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
